import React, { Component } from "react";
import {
  Row,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Col,
  FormGroup,
  Label,
  Table,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { AvForm, AvField } from "availity-reactstrap-validation";
import moment from "moment";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";

//select
import Select from "react-select";

import {
  productModel_close,
  getPIAllProducts,
  SetParams,
  getRowProducts,
  InputChangeValue,
  SelecteChangeValue,
  AddToSelectedItems,
} from "../../../store/SRPurchaseIndent/actions";

import { getMiniBasicUnits } from "../../../store/Mini/actions";

class PIAddItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal_static: false,
      activeTab: 1,
      isAlertOpen: true,
    };

    this.toggleTab = this.toggleTab.bind(this);
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.addtocartProduct = this.addtocartProduct.bind(this);
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 3) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  }
  componentDidMount() {
    this.props.getMiniBasicUnits();
  }

  //----------------------
  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.SetParams({
        ...this.props.params,
        search: e.target.value,
        page: 1,
      });
      this.props.getPIAllProducts(
        {
          ...this.props.params,
          search: e.target.value,
          page: 1,
          type:2,
        },
        true
      );
    }
  };
  autohandleSearch = (e) => {
    this.props.SetParams({
      ...this.props.params,
      search: e.target.value,
      page: 1,
    });
    if (e.target.value === "") {
      this.props.getPIAllProducts(
        {
          ...this.props.params,
          search: e.target.value,
          page: 1,
          type:2,
        },
        true
      );
    }
  };
  addtocartProduct() {
    var products = {
      ...this.props.PIRowData,
      date:
        this.props.PIRowData.date == null
          ? moment(new Date()).format("YYYY-MM-DD")
          : this.props.PIRowData.date,
      unit: {
        id:
          this.props.PIRowData.unit_id == null
            ? this.props.productRowlist?.units[0].id
            : this.props.PIRowData.unit_id,
        name:
          this.props.PIRowData.unitsLabel == null
            ? this.props.productRowlist?.units[0].name
            : this.props.PIRowData.unitsLabel,
      },
      code: this.props.productRowlist.code,
      product: this.props.productRowlist,
    };

    this.props.AddToSelectedItems(products);
    this.toggleTab(1);
    this.addForm && this.addForm.reset();
  }
  openPage(pageNo) {
    this.props.SetParams({
      ...this.props.params,
      page: pageNo,
    });
    this.props.getPIAllProducts(
      {
        ...this.props.params,
        page: pageNo,
        type:2,
      },
      false
    );
  }
  handleScroll = (e) => {
    const target = e.target;
    if (target.scrollTop !== 0) {
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        if (this.props.params.page <= this.props.params.no_of_pages) {
          this.openPage(this.props.params.page + 1);
        }
      }
    }
  };
  //>>>>>>>>>>>>>>>>>>>>>>>

  render() {
    var data = this.props.productslist;

    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.productsModel}
          // toggle={this.tog_static}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader
            toggle={() => {
              this.props.productModel_close();
              this.toggleTab(1);
            }}
          >
            PI Add Item
          </ModalHeader>
          <ModalBody className="pt-0">
            <Row className="justify-content-center">
              <Col md={12}>
                <Row>
                  <Col lg={12}>
                    <Nav tabs className="nav-tabs-custom mb-2">
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab(1);
                          }}
                          className={classnames(
                            { active: this.state.activeTab === 1 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          Items List |<span> {this.props.productsCount}</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          //   onClick={() => {
                          //     this.toggleTab(2);
                          //   }}
                          className={classnames(
                            { active: this.state.activeTab === 2 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                          //   className={
                          //     this.state.activeTab === 1
                          //       ? "previous disabled"
                          //       : "previous"
                          //   }
                        >
                          {(this.state.activeTab === 2 ||
                            this.state.activeTab === 3) && <span>Details</span>}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab(3);
                          }}
                          className={classnames(
                            { active: this.state.activeTab === 3 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          {(this.state.activeTab === 2 ||
                            this.state.activeTab === 3) && <span>Units</span>}
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId={1}>
                        <div className="mt-2">
                          <FormGroup className="m-0">
                            <InputGroup>
                              <Input
                                type="text"
                                name="search"
                                className="form-control d-inline-block"
                                placeholder="Search Item"
                                value={this.props.params.search}
                                onChange={(e) => this.autohandleSearch(e)}
                                onKeyDown={(e) => this.handleSearch(e)}
                              />
                              <InputGroupAddon addonType="append">
                                {this.props.params.search !== "" && (
                                  <Button
                                    color="light"
                                    type="button"
                                    onClick={() => {
                                      this.props.SetParams({
                                        ...this.props.params,
                                        search: "",
                                        page: 1,
                                        // department:
                                        //   this.props.mrRowData.department_id,
                                      });
                                      this.props.getPIAllProducts(
                                        {
                                          search: "",
                                          page: 1,
                                          type:2,
                                          // department:
                                          //   this.props.mrRowData.department_id,
                                        },
                                        true
                                      );
                                    }}
                                  >
                                    <i className="text-danger ri-close-line"></i>
                                  </Button>
                                )}

                                <Button
                                  color="light"
                                  type="button"
                                  onClick={() => {
                                    this.props.getPIAllProducts(
                                      {
                                        search: this.props.params.search,

                                        page: 1,
                                        type:2,
                                        // department:
                                        //   this.props.mrRowData.department_id,
                                      },
                                      true
                                    );
                                  }}
                                >
                                  <i className="ri-search-line"></i> Search
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>
                          </FormGroup>
                        </div>

                        <div
                          className="table-responsive"
                          onScroll={this.handleScroll}
                          style={{
                            maxHeight: "450px",
                            overflowY: "auto",
                          }}
                        >
                          <Table className="table-centered mb-0">
                            <thead className="bg-light ">
                              <tr>
                                <th style={{ width: "120px" }}>Item Images</th>
                                <th style={{ width: "220px" }}>Item Name</th>
                                <th style={{ width: "120px" }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.productsCount === 0 ? (
                                <>
                                  {this.props.dataLoading === true ? (
                                    <tr className="text-center">
                                      <td colSpan="3">
                                        <Spinner color="primary" />
                                      </td>
                                    </tr>
                                  ) : (
                                    <tr className="text-center">
                                      <td colSpan="3">No Items Found. </td>
                                    </tr>
                                  )}
                                </>
                              ) : (
                                <>
                                  {data.length === 0 ? (
                                    <>
                                      {this.props.dataLoading === true ? (
                                        <tr className="text-center">
                                          <td colSpan="3">
                                            <Spinner color="primary" />
                                          </td>
                                        </tr>
                                      ) : (
                                        <tr className="text-center">
                                          <td
                                            colSpan="3"
                                            className="text-danger"
                                          >
                                            Already item has been added in the
                                            List
                                          </td>
                                        </tr>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {data?.map((product, key) => (
                                        <tr key={key}>
                                          <td className="nowrap ">
                                            <img
                                              src={
                                                product.image == null
                                                  ? DefaultImg
                                                  : product.image
                                              }
                                              alt="product-img"
                                              title="product-img"
                                              className="avatar-sm"
                                            />
                                          </td>
                                          <td>
                                            <div className="font-size-12">
                                              {product.code}
                                            </div>
                                            <h5 className="mb-0 font-size-14 text-truncate">
                                              <Link
                                                to="#"
                                                className="text-dark"
                                                onClick={() => {
                                                  this.toggleTab(2);
                                                  this.props.getRowProducts(
                                                    product.id
                                                  );
                                                  this.addForm &&
                                                    this.addForm.reset();
                                                }}
                                              >
                                                {product.name}
                                              </Link>
                                            </h5>
                                          </td>

                                          <td className="nowrap">
                                            <Button
                                              type="sudmit"
                                              color="primary"
                                              className="waves-effect waves-light mr-2"
                                              onClick={() => {
                                                this.toggleTab(2);
                                                this.props.getRowProducts(
                                                  product.id
                                                );
                                                this.addForm &&
                                                  this.addForm.reset();
                                              }}
                                            >
                                              <i className="mdi mdi-arrow-top-right mr-2"></i>
                                              Add
                                            </Button>
                                          </td>
                                        </tr>
                                      ))}
                                      {this.props.dataLoading === true && (
                                        <tr className="text-center">
                                          <td colSpan="3">
                                            <Spinner color="primary" />
                                          </td>
                                        </tr>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </TabPane>
                      <TabPane tabId={2}>
                        <Row>
                          <Col md={5}>
                            <div className="product-detail text-center">
                              <img
                                src={
                                  this.props.productRowlist?.image == null
                                    ? DefaultImg
                                    : this.props.productRowlist?.image
                                }
                                alt="product-img"
                                title="product-img"
                                className="product-img img-fluid mx-auto tab-img rounded"
                              />
                            </div>
                          </Col>
                          <Col md={7}>
                            <h5 className="mt-1 mb-1">
                              {this.props.productRowlist?.name}
                            </h5>
                            <div>
                              <p className="d-inline-block">
                                <span style={{ fontWeight: "bold" }}>
                                  Code :
                                </span>
                                <i>{this.props.productRowlist?.code}</i>
                              </p>
                              <p className="float-right d-inline-block mr-5">
                                <span style={{ fontWeight: "bold" }}>
                                  Section :
                                </span>
                                <i>{this.props.productRowlist?.section.name}</i>
                              </p>
                            </div>
                            <Row>
                              <Col md={12}>
                                <div className="Order-panel-content">
                                  {/* <h5 className="font-size-14"> Specification : </h5> */}
                                  <div className="list-column">
                                    <ul className="list-style-two p-0 product-desc-list">
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Department :
                                        </span>
                                        <span className="dtl">
                                          {
                                            this.props.productRowlist
                                              ?.department.name
                                          }
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Category :
                                        </span>
                                        <span className="dtl">
                                          {
                                            this.props.productRowlist?.category
                                              .name
                                          }
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Product Group :
                                        </span>
                                        <span className="dtl">
                                          {
                                            this.props.productRowlist?.group
                                              .name
                                          }
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Base Unit :
                                        </span>
                                        <span className="dtl">
                                          {
                                            this.props.productRowlist?.baseunit
                                              .name
                                          }
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Specifications :
                                        </span>
                                        {this.props.productRowlist
                                          ?.description !== null ? (
                                          <span
                                            className="font-weight-medium"
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                this.props.productRowlist?.description.replaceAll(
                                                  "\n",
                                                  "<br/>"
                                                ),
                                            }}
                                          ></span>
                                        ) : (
                                          <span className="font-weight-medium">
                                            {
                                              this.props.productRowlist
                                                ?.description
                                            }
                                          </span>
                                        )}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <hr className="my-1" />

                            <Col md={12}>
                              <AvForm
                                className="form-horizontal"
                                onValidSubmit={this.addtocartProduct}
                                ref={(c) => (this.addForm = c)}
                              >
                                <Row>
                                  <Col md={5}>
                                    <FormGroup>
                                      <Label htmlFor="item_qty">
                                        Quantity{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <AvField
                                        className="mb-0 form-control "
                                        min={0}
                                        // max={100}
                                        type="number"
                                        // step="1"
                                        name="qty"
                                        id="item_qty"
                                        value={this.props.PIRowData?.qty}
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage: "Please enter Qty",
                                          },
                                          pattern: {
                                            value:
                                              "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                            errorMessage:
                                              "Qty can compose numbers and 3 decimals ",
                                          },
                                        }}
                                        onChange={this.ChangeHandeler}
                                        placeholder="Qty"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={3}>
                                    <FormGroup>
                                      <Label htmlFor="units_select">
                                        Units
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Select
                                        id="units_select"
                                        name="units_select"
                                        required="required"
                                        options={this.props.productRowlist?.units.map(
                                          (item, index) => ({
                                            label: item.name,
                                            value: item.id,
                                          })
                                        )}
                                        value={{
                                          label:
                                            this.props.PIRowData?.unitsLabel ==
                                            null
                                              ? this.props.productRowlist
                                                  ?.units[0].name
                                              : this.props.PIRowData
                                                  ?.unitsLabel,
                                          value:
                                            this.props.PIRowData?.unit_id ==
                                            null
                                              ? this.props.productRowlist
                                                  ?.units[0].id
                                              : this.props.PIRowData?.unit_id,
                                        }}
                                        onChange={(e) => {
                                          this.props.SelecteChangeValue({
                                            key: "unitsLabel",
                                            label: e.label,
                                            key2: "unit_id",
                                            value: e.value,
                                          });
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col md={4}>
                                    <FormGroup>
                                      <Label htmlFor="requiredDate">
                                        Required Date{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <AvField
                                        type="date"
                                        name="date"
                                        min={moment(new Date()).format(
                                          "YYYY-MM-DD"
                                        )}
                                        id="requiredDate"
                                        className="mb-0 form-control "
                                        placeholder="Select Date"
                                        value={
                                          this.props.PIRowData?.date == null
                                            ? moment(new Date()).format(
                                                "YYYY-MM-DD"
                                              )
                                            : this.props.PIRowData?.date
                                        }
                                        onChange={this.ChangeHandeler}
                                        validate={{
                                          required: { value: true },
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={5}>
                                    <FormGroup>
                                      <Label htmlFor="Make">
                                        Make{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <AvField
                                        type="textarea"
                                        name="make"
                                        id="Make"
                                        className="mb-0 form-control "
                                        value={this.props.PIRowData?.make}
                                        onChange={this.ChangeHandeler}
                                        validate={{
                                          required: { value: true },
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col md={7}>
                                    <FormGroup>
                                      <Label htmlFor="Description">
                                        Description
                                      </Label>
                                      <AvField
                                        type="textarea"
                                        name="description"
                                        id="Description"
                                        className="mb-0 form-control "
                                        placeholder="Add Description"
                                        value={
                                          this.props.PIRowData?.description
                                        }
                                        onChange={this.ChangeHandeler}
                                        validate={
                                          {
                                            // required: { value: true },
                                          }
                                        }
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={12}>
                                    <div className="float-right">
                                      <FormGroup>
                                        <Button
                                          type="button"
                                          color="light"
                                          className="waves-effect waves-light d-inline-block mr-2"
                                          onClick={() => {
                                            this.toggleTab(1);
                                          }}
                                        >
                                          Back To List
                                        </Button>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="waves-effect waves-light d-inline-block mb-2"
                                        >
                                          <i className="mdi mdi-plus mr-1"></i>
                                          Add Item
                                        </Button>
                                      </FormGroup>
                                    </div>
                                  </Col>
                                </Row>
                              </AvForm>
                            </Col>
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId={3}>
                        <Row>
                          <Col md={12}>
                            <div className="table-responsive table-bordered m-2">
                              <Table className="table-centered mb-0">
                                <thead className="bg-light ">
                                  <tr>
                                    <th style={{ width: "120px" }}>S.No</th>
                                    <th style={{ width: "220px" }}>
                                      Units Name
                                    </th>
                                    <th style={{ width: "120px" }}>Units</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.props.productRowlist?.units.map(
                                    (unit, key) => (
                                      <tr key={key}>
                                        <td className="nowrap ">{key + 1}</td>
                                        <td>{unit.name}</td>
                                        <td>{unit.units}</td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </Col>
                          <Col>
                            <Button
                              type="button"
                              color="light"
                              className="waves-effect waves-light float-right mt-2"
                              onClick={() => {
                                this.toggleTab(2);
                              }}
                            >
                              Back To Product
                            </Button>
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { BasicUnitlist } = state.Mini;
  const {
    productsModel,
    productslist,
    productsCount,
    params,
    productRowlist,
    PIRowData,
    dataLoading,
  } = state.SRpurchaseIndent;

  return {
    BasicUnitlist,
    productsModel,
    productslist,
    productsCount,
    params,
    productRowlist,
    PIRowData,
    dataLoading,
    //------------
  };
};

export default connect(mapStatetoProps, {
  productModel_close,
  getPIAllProducts,
  SetParams,
  getMiniBasicUnits,
  InputChangeValue,
  SelecteChangeValue,
  getRowProducts,
  AddToSelectedItems,
})(PIAddItem);
